import { DevJwtPanel } from '../dev/dev-jwt-panel'

/**
 * AppFooter - host for the collapsible `DevJwtPanel`.
 *
 * It used to also carry the build / environment strip. The design handoff has
 * no bottom bar, so that strip moved into the sidebar footer (see
 * `sidebar.tsx`), alongside the tenant indicator. What is left is a dev-only
 * affordance, so the whole strip disappears in production rather than leaving
 * an empty bordered band under the shell.
 *
 * The `prod` check mirrors the one inside `DevJwtPanel`: the panel gates its
 * own content, and this gates the chrome around it. Read in-body, not at module
 * scope, so it stays stubbable with `vi.stubEnv` (see `dev/flags.ts`).
 *
 * Mounted once at the `App` level rather than per screen.
 */
export function AppFooter(): JSX.Element | null {
  const env = import.meta.env.VITE_ENV ?? 'dev'
  if (env === 'prod') return null

  return (
    <footer
      aria-label="Development tools"
      className="flex-none border-t border-border-default bg-bg-surface px-murmuration-6 py-murmuration-2 text-murmuration-label text-text-muted"
    >
      <DevJwtPanel />
    </footer>
  )
}
